import { render, staticRenderFns } from "./onboardUser.vue?vue&type=template&id=3c293848&scoped=true"
import script from "./onboardUser.vue?vue&type=script&lang=js"
export * from "./onboardUser.vue?vue&type=script&lang=js"
import style0 from "./onboardUser.vue?vue&type=style&index=0&id=3c293848&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c293848",
  null
  
)

export default component.exports